<app-header></app-header>
<main class="timeapp mobile" style="padding: 0.5em; display: flex; flex-direction: column;">
    <form [formGroup]="settingsForm" class="form-wrapper" style="display: flex; flex-direction: column; flex: 1;">
        <mat-form-field floatLabel="always">
            <mat-label> {{ "SETTINGS.Sprache" | translate }}</mat-label>
            <mat-select formControlName="language">
                <mat-option value="de">Deutsch</mat-option>
                <mat-option value="fr">Französisch</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>{{
                    "MAIN_APP_SETTINGS.startseite" | translate
                }}
            </mat-label>
            <mat-select (selectionChange)="dropdownStartPageChange($event)" [(value)]="startPage">
                <mat-option *ngFor="let site of startSites" [value]="site.value">
                    {{ site.viewValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field floatLabel="always">
            <mat-label> {{ "SETTINGS.ZeitLoschenNach" | translate }}</mat-label>
            <input formControlName="deleteTimeEntryDays" matInput min="0" type="number"/>
        </mat-form-field>

        <mat-form-field floatLabel="always">
            <mat-label> {{ "SETTINGS.defaultCostCenter" | translate }}</mat-label>
            <mat-select formControlName="defaultCostCenter">
                <mat-option [value]="0" style="background-color: lightgray;">Keine</mat-option>
                <mat-option *ngFor="let k of kostenstellen" [value]="k.costCenterID">{{ k.costCenterID }} {{ k.description }}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title class="block2_title">
                    {{ "MAIN_APP_SETTINGS.backup" | translate }}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="backup">
                <div (click)="downloadBackup()" class="download btn">
                    {{ "MAIN_APP_SETTINGS.downloadBackup" | translate }}
                </div>

                <div style="display: flex; flex-direction: row;">
                    <div>
                        <div #vinbkupUpload class="upload" style="width:250px; display: flex;">
                            <label for="vinbkInput" style="margin: auto; align-self: center;">{{ getPath }}</label>
                            <input #vinbkInput (change)="onChange($event)" id="vinbkInput" style="height: 100%; width:100%; opacity: 0; position: absolute; left: 0; top: 0; right: 0; bottom: 0;"
                                   type="file">
                        </div>
                    </div>
                    <button #vinbkApply (click)="loadBackup()" class="btn badFile">
                        {{
                            vinbkInput.value ? ("MAIN_APP_SETTINGS.applyBackup" | translate) : ("MAIN_APP_SETTINGS.uploadBackup" |
                                translate)
                        }}
                    </button>
                </div>
            </div>

            <div class="server-backup">
                <h4>{{ "MAIN_APP_SETTINGS.serverBackup" | translate }}</h4>
                @let backupInfo = serverBackupInfo();
                @if (backupInfo?.available) {
                    <div class="server-backup-status">
                        {{ "MAIN_APP_SETTINGS.serverBackupAvailable" | translate }}: {{ backupInfo!.createdAt | date:'dd.MM.yyyy HH:mm' }}
                    </div>
                } @else {
                    <div class="server-backup-status">{{ "MAIN_APP_SETTINGS.noServerBackup" | translate }}</div>
                }
                <div style="display: flex; flex-direction: row; column-gap: 0.5em;">
                    <button (click)="downloadServerBackup()" mat-raised-button [disabled]="!helperService.isWebServiceAvailable() || !backupInfo?.available">
                        {{ "MAIN_APP_SETTINGS.downloadServerBackup" | translate }}
                    </button>
                    <button (click)="restoreServerBackup()" mat-raised-button color="warn" [disabled]="!helperService.isWebServiceAvailable() || !backupInfo?.available">
                        {{ "MAIN_APP_SETTINGS.restoreServerBackup" | translate }}
                    </button>
                </div>
            </div>
        </mat-expansion-panel>

        <span style="display: flex; align-items: center;">
			<span (click)="startDBControl()">
				<fa-icon [icon]="faDatabase" style="color: black; padding-left: 10px;"></fa-icon>
				DB Control
			</span>
			<mat-checkbox (change)="setDebugMode($event.checked)" [checked]="webUserConfig.debugMode" class="cbDebung-margin" style="width: 60%">
				{{ "MAIN_APP_SETTINGS.debugModus" | translate }}
			</mat-checkbox>
		</span>
    </form>

    <mat-accordion *ngIf="showSettings">
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title class="block2_title">
                    Benutzer-Einstellungen
                </mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>
            <div>
                <div>
                    <mat-card appearance="outlined" class="mat-elevation-z4">
                        <div style="width: 60%">
                            <mat-form-field appearance="fill" style="width: 200px">
                                <mat-label>Startseite</mat-label>
                                <mat-select (selectionChange)="dropdownStartPageChange($event)" [(value)]="startPage">
                                    <mat-option *ngFor="let site of startSites" [value]="site.value">
                                        {{ site.viewValue }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <table style="width: 160px">
                            <tr>
                                <td>
                                    {{ "SETTINGS.CalenderTime" | translate }}
                                </td>
                                <td>
                                    <mat-form-field style="width: 75px">
                                        <input (input)="onGridStartChange($event)" [(ngModel)]="timeGridStart" matInput placeholder="Zeitraster Start" type="time"/>
                                    </mat-form-field>
                                </td>
                                <td>
                                    <mat-form-field style="margin: 0 0 0 10px; width: 75px">
                                        <input (input)="onGridEndChange($event)" [(ngModel)]="timeGridEnd" matInput placeholder="Zeitraster Ende" type="time"/>
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ "SETTINGS.ServiceAppTimes" | translate }}
                                </td>
                                <td>
                                    <mat-form-field style="width: 75px">
                                        <input (input)="onWorkDayStartChange($event)" [(ngModel)]="timeWorkDayStart" matInput placeholder="Arbeitstag Start" type="time"/>
                                    </mat-form-field>
                                </td>
                                <td>
                                    <mat-form-field style="margin: 0 0 0 10px; width: 75px">
                                        <input (input)="onWorkDayEndChange($event)" [(ngModel)]="timeWorkDayEnd" matInput placeholder="Arbeitstag Ende" type="time"/>
                                    </mat-form-field>
                                </td>
                            </tr>
                        </table>
                    </mat-card>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <div class="version-info">
        <div class="user-info">
            <div>
                {{ anwender.firstName }} {{ anwender.lastName }}
            </div>
            <div>
                {{ anwender.mandator }} ({{ anwender.mandatorID }})
            </div>
        </div>
        <div class="device-info">
            <div>
                {{ device.ua }}
            </div>
            <div>
                {{ device.device.model }} | {{ device.device.type }} | {{ device.device.orientation }}
            </div>

            <div>
                {{ device.browser.name }} | {{ device.browser.version }}
            </div>
        </div>
        <div>
            <div *ngIf="svcVinavonUpdate.newVersionFound | async">
			<span>
				<button (click)="svcVinavonUpdate.askUserToDoUpdate()" class="btn-block" color="warn" mat-stroked-button>Update vinavon</button>
			</span>
            </div>
            <div>
                <img alt="Swiss Soft Solutions GmbH" src="assets/images/logo_mobile.png" style="margin: 0 0 0 0; width: 250px;"/>
            </div>
            <div style="font-size: smaller;">
                {{ vinavonVersion }}
            </div>
        </div>
    </div>
</main>
<footer>
    <mat-icon (click)="goBack()" class="icon-size">
        arrow_back
    </mat-icon>
</footer>
